<ion-content>
  <iframe [src]="dashboardUrl" frameborder="0" style="display: block;" width="100%" height="100%"
          allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>
</ion-content>
